import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { SaleOrderBearing } from '../sale-order-bearing';
import { SaleOrderBearingVisibilityBuilder } from './sale-order-bearing-visibility-builder';

export class SaleOrderBearingBuilder {
  static fromJson(json): SaleOrderBearing {
    return (json) ? new SaleOrderBearing(
        json.hash,
        json.saleOrderHash,
        parseNumber(json.bearingDate),
        json.observations,
        json.loadingCustomerHash,
        json.loadingCustomerBusinessName,
        json.loadingCustomerNif,
        json.loadingPlace,
        json.unloadingCustomerHash,
        json.unloadingCustomerBusinessName,
        json.unloadingPlace,
        json.unloadingCustomerNif,
        (isArray(json.saleOrderBearingVisibilities)) ? mapCollection(
            SaleOrderBearingVisibilityBuilder.fromJson, json.saleOrderBearingVisibilities) : [],
    ) : null;
  }

  static fromJsonList(list): SaleOrderBearing[] {
    return (isArray(list)) ? mapCollection(SaleOrderBearingBuilder.fromJson, list) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-bearing-builder.ts